import type {
  ReportDomain,
  ReportMetric,
  ReportMetricUnit,
  ScreeningReport,
} from "../entities/ScreeningReport";

export const TYPICAL_PERCENTILE_RANGE = { min: 25, max: 75 };

const UNIT_FRACTION_DIGITS: Record<ReportMetricUnit, number> = {
  percent: 1,
  seconds: 2,
  milliseconds: 0,
  syllablesPerSecond: 1,
  count: 0,
  average: 1,
  index: 2,
};

export const formatMetricNumber = (metric: ReportMetric, locale: string) =>
  new Intl.NumberFormat(locale, {
    maximumFractionDigits: UNIT_FRACTION_DIGITS[metric.unit],
  }).format(metric.value);

export const listReportMetrics = (
  report: ScreeningReport,
): { domain: ReportDomain["key"]; metric: ReportMetric }[] =>
  report.domains.flatMap((d) =>
    d.groups.flatMap((g) => g.metrics.map((metric) => ({ domain: d.key, metric }))),
  );

export const summariseReport = (report: ScreeningReport) => {
  const metrics = listReportMetrics(report);
  const withinTypical = metrics.filter(
    ({ metric }) =>
      metric.percentile >= TYPICAL_PERCENTILE_RANGE.min &&
      metric.percentile <= TYPICAL_PERCENTILE_RANGE.max,
  );
  const belowTypical = metrics.filter(
    ({ metric }) => metric.percentile < TYPICAL_PERCENTILE_RANGE.min,
  );
  return { total: metrics.length, within: withinTypical.length, belowTypical };
};
